import { ApolloClient, InMemoryCache, HttpLink, from } from "@apollo/client";
import { onError } from "@apollo/client/link/error";

const { REACT_APP_SPACE_ID: SPACE_ID, REACT_APP_ACCESS_TOKEN: ACCESS_TOKEN } = process.env;

const errorLink = onError(({ graphqlErrors }) => {
  if (graphqlErrors)
    graphqlErrors.map(({ message }) => {
      console.error(`Graphql error: ${message}`);
      return "";
    });
});

const link = from([
  errorLink,
  new HttpLink({
    uri: `https://graphql.contentful.com/content/v1/spaces/${SPACE_ID}`,
    credentials: "same-origin",
    headers: {
      Authorization: `Bearer ${ACCESS_TOKEN}`,
    },
  }),
]);

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: link,
});
